var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.classObject, _vm.studyClass],style:(_vm.styleObject)},[_vm._v(" "+_vm._s(_vm.studyString)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }